import script from "./TerminStepLocation.vue?vue&type=script&setup=true&lang=js"
export * from "./TerminStepLocation.vue?vue&type=script&setup=true&lang=js"

import "./TerminStepLocation.vue?vue&type=style&index=0&id=0961b6f0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0961b6f0"]])

export default __exports__